module.exports = __webpack_public_path__ + "img/40_discount22.1cb71a52.png";